module.exports = __webpack_public_path__ + "img/house_illustration.png";